import { useCallback } from "react";
import { useCustomisation } from "../context/CustomisationContext";
import { DropdownPortal, usePortal } from "../context/PortalsContext";

/**
 * Atomically resets cached customisations and sets the new selected portal.
 */
export const useSelectPortal = () => {
  const { dispatch: portalsDispatch } = usePortal();
  const { dispatch: customisationsDispatch } = useCustomisation();

  return useCallback(
    (portal: DropdownPortal) => {
      customisationsDispatch({ type: "RESET_ALL_PAGES" });
      portalsDispatch({ type: "SET_SELECTED_PORTAL", payload: portal });
    },
    [customisationsDispatch, portalsDispatch],
  );
};
